import { adler32, getCookie, log } from "./";
export var validDataTimeout = 300000; // 5 minutes in ms
export var contextKey = "shoppingContext";
export var userCookieName = "ShoppingKey";
export var isValidTimestamp = function (timestamp) {
    return Date.now() - timestamp <= validDataTimeout;
};
// Both sessionStorage or localStorage could be used here.
// The sessionStorage doesn't support triggering syncing events on other browser tabs.
// The sessionStorage should clean up stored data after the browser tab gets closed.
// But the browser's restore-session-on-reopen functionality may clash with this.
// Both storage types have no connection with server-side session,
// so, if working with server session data, manual cleanups / refreshing
// has to be solved anyway.
export var storage = window.localStorage;
export var isStorageAvailable = Boolean(storage);
if (!isStorageAvailable) {
    log("Storage is not available.");
}
// In Online session, there should always be some value set.
// The 'unknown' value is just a fallback for testing.
export var getUserCheck = function () { var _a; return adler32(((_a = getCookie(userCookieName)) !== null && _a !== void 0 ? _a : "").trim() || "unknown"); };
var parseValue = function (serializedData) {
    var parsedValue;
    try {
        parsedValue = JSON.parse(serializedData);
    }
    catch (error) {
        log("Error parsing serialized data:", error);
    }
    return parsedValue;
};
export var getItem = function (key) {
    if (!isStorageAvailable) {
        return undefined;
    }
    var data = storage.getItem(key);
    if (!data) {
        log("Item with key '" + key + "' wasn't found in storage.");
        return undefined;
    }
    var parsedValue = parseValue(data);
    if (!parsedValue) {
        log("Error getting stored item with key '" + key + "'.");
        return undefined;
    }
    var savedTimestamp = parsedValue.savedTimestamp, value = parsedValue.value, userCheck = parsedValue.userCheck;
    if (!isValidTimestamp(savedTimestamp)) {
        storage.removeItem(key);
        log("Stored item with key '" + key + "' has expired and was deleted.");
        return undefined;
    }
    if (userCheck !== getUserCheck()) {
        storage.removeItem(key);
        log("Item with key '" + key + "' was stored for different user and was deleted.");
        return undefined;
    }
    log("Item with key " + key + " was found in storage.\n\t", parsedValue);
    return value;
};
export var setItem = function (key, value) {
    if (!isStorageAvailable) {
        return false;
    }
    var data = {
        savedTimestamp: Date.now(),
        value: value,
        userCheck: getUserCheck(),
    };
    try {
        storage.setItem(key, JSON.stringify(data));
        log("Stored item with key '" + key + "', value:\n\t", data);
    }
    catch (error) {
        log("Error storing item with " + key + ":", error);
        return false;
    }
    return true;
};
export var removeItem = function (key) {
    try {
        storage.removeItem(key);
        log("Stored item with key '" + key + "' was removed.");
    }
    catch (error) {
        log("Error removing item with key '" + key + "':", error);
        return false;
    }
    return true;
};
export var listenToStoredItemChanges = function (key, callback) {
    return window.addEventListener("storage", function (event) {
        if (event.storageArea !== storage || event.key !== key) {
            return undefined;
        }
        log("Storage change event from another browser tab was received for item with key '" + key + "'.");
        if (event.newValue === null) {
            log("Stored item with '" + key + "' was removed in another browser window.");
            removeItem(key);
            return callback === null || callback === void 0 ? void 0 : callback(undefined);
        }
        var parsedValue = parseValue(event.newValue);
        if (!parsedValue) {
            return undefined;
        }
        try {
            storage.setItem(key, event.newValue);
            log("Stored item with key '" + key + "', value:\n\t", parsedValue);
        }
        catch (error) {
            log("Error storing item with key '" + key + "':", error);
        }
        return callback === null || callback === void 0 ? void 0 : callback(parsedValue.value);
    });
};
